import type { BookDto } from './book';

/**
 * Backend DTOs mirrored from:
 *   learnleaf.Application.Contracts.Licenses.LicenseWithNavigationPropertiesDto
 *   LicenseDto, BookDto, IdentityUserDto, BooksellerDto
 * Only fields the UI consumes are included; add more as needed.
 */
export enum LicenseStatus {
  Active = 1,
  Expired = 2,
  Revoked = 3,
  Suspended = 4,
}

export enum LicenseType {
  Purchase = 1,
  Rental = 2,
  Subscription = 3,
}

export interface LibraryLicenseDto {
  id: string;
  bookId: string;
  studentId: string;
  booksellerId?: string | null;
  externalLicenseId?: string | null;
  lastSyncedAt?: string | null;
  licenseType: LicenseType;
  status: LicenseStatus;
  activationDate?: string | null;
  expirationDate?: string | null;
  maxConcurrentDevices: number;
}

export interface LibraryBooksellerDto {
  id: string;
  name: string;
  slug: string;
  displayName: string;
  logoUrl?: string | null;
}

export interface LicenseWithNavigationPropertiesDto {
  license: LibraryLicenseDto;
  book: BookDto;
  bookseller?: LibraryBooksellerDto | null;
}

/**
 * Flattened UI row used by MyLibraryPage. Preserves the existing BookDto shape
 * so card rendering doesn't change, and adds optional bookseller fields the pill consumes.
 */
export interface LibraryBook extends BookDto {
  licenseId: string;
  licenseStatus: LicenseStatus;
  lastSyncedAt?: string | null;
  booksellerId?: string | null;
  booksellerSlug?: string | null;
  booksellerName?: string | null;
  booksellerLogoUrl?: string | null;
}

export interface LibrarySyncResultDto {
  added: unknown[];
  removed: unknown[];
  updated: unknown[];
  syncedBooksellerIds: string[];
  errors: string[];
  hasChanges: boolean;
}
